import { render, staticRenderFns } from "./RPPagination.vue?vue&type=template&id=5e181db4&"
import script from "./RPPagination.vue?vue&type=script&lang=js&"
export * from "./RPPagination.vue?vue&type=script&lang=js&"
import style0 from "./RPPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports